import { vaultGetRequest } from '../helpers';
import type { ISocialJobInfo } from './fetch-social-jobs-response';
import { fetchSocialJobsResponseSchema } from './fetch-social-jobs-response';

export async function fetchSocialJobsApi(): Promise<ISocialJobInfo[]> {
  const res = await vaultGetRequest({
    path: '/social/jobs',
    schema: fetchSocialJobsResponseSchema,
  });
  return res.jobs;
}
